import { render, staticRenderFns } from "./createRecord.vue?vue&type=template&id=53c323db&scoped=true&"
import script from "./createRecord.vue?vue&type=script&lang=js&"
export * from "./createRecord.vue?vue&type=script&lang=js&"
import style0 from "./createRecord.vue?vue&type=style&index=0&id=53c323db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c323db",
  null
  
)

export default component.exports